import { Box, Grid, Text, Tooltip } from '@mantine/core';
import { IconQuestionMark } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import algorithms from '../../constants/Algorithms';
import SearchableCombobox from '../SearchableCombobox';
import SuperAdminBadge from '../SuperAdmin/SuperAdminBadge';

const AlgorithmSelector = ({ controlCol, labelCol, algorithm, scope, handleChange }) => {
  const { user } = useSelector((state) => state.auth);
  const { domain } = useSelector((state) => state.domain);
  const deepAiToggle = domain.featureToggles.find((t) => t.name === 'deepAiEnabled' && t.enabled);

  const algorithmsInScope = Object.entries(algorithms).filter(([key, { name, allowedScopes, hiddenOutsideReleva }]) => {
    if (key === 'null' && scope === 'ads') {
      return false;
    }
    if (hiddenOutsideReleva && !user.email.endsWith('@releva.ai')) {
      return false;
    }
    if (name.includes('Deep AI') && !deepAiToggle) {
      return false;
    }
    if (scope === 'ads') {
      return algorithm === key || (allowedScopes && allowedScopes.includes('ads'));
    }
    return algorithm === key || allowedScopes === undefined || allowedScopes.includes(scope);
  });

  const options = algorithmsInScope.map(([value, { name, hiddenOutsideReleva }]) => {
    return {
      value,
      label: name,
      // hiddenOutsideReleva options are already filtered out above for users
      // outside releva.ai, so whoever sees them is staff — badge them outright.
      rightSection: hiddenOutsideReleva ? (
        <SuperAdminBadge show label="Releva only" tooltip="Internal algorithm — hidden from users outside Releva" />
      ) : null,
    };
  });

  const tooltipContent = (
    <Box ta="left">
      {algorithmsInScope.map(([key, value]) => (
        <div key={key}>
          <b>{value.name}</b> - {value.description}
        </div>
      ))}
    </Box>
  );

  return (
    <Grid data-tour="recommenderAlgorithm" align="center" mt="md">
      <Grid.Col span={{ base: 12, sm: labelCol ? labelCol : controlCol ? 12 - controlCol : 4 }}>
        <Text fw={500}>
          Algorithm&nbsp;
          <Tooltip label={tooltipContent} position="right" multiline w={640}>
            <span style={{ cursor: 'help' }}>
              <IconQuestionMark size={14} />
            </span>
          </Tooltip>
        </Text>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: controlCol ? controlCol : labelCol ? 12 - labelCol : 8 }}>
        <SearchableCombobox
          clearable={true}
          options={options}
          value={algorithm === null ? 'null' : algorithm}
          onChange={(value) => handleChange({ target: { name: 'algorithm', value: value === 'null' ? null : value } })}
          placeholder="Select algorithm or leave blank to rely on boosts / filters only"
          searchPlaceholder="Search algorithms..."
          emptyMessage="No algorithms found"
        />

        <Text size="sm" c="dimmed">
          {algorithms[algorithm]
            ? algorithms[algorithm].description
            : 'Not choosing an algorithm means that the products to return will be entirely determined by boosts and filters.'}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

export default AlgorithmSelector;
